<template>
  <div>
    <el-dialog
    :title="defaultInfo.title"
    :visible.sync="visible"
    :before-close="handleClose">
    <div class="form-box">
        <div class="row" v-if="defaultInfo.modalType === 'mine'">
            <div class="col-1 require">{{$t('componentsReply.complaintObject')}}：</div>
            <div class="col-2">
            <el-select v-model="form.complainObj" :placeholder="$t('componentsReply.choComplaintObject')" style="width:100%">
                <el-option
                v-for="item in complainObjOptions"
                :key="item.value"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
            </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
            <div class="col-1 require">{{$t('componentsReply.complaintProblem')}}：</div>
            <div class="col-2">
                <el-input
                :placeholder="$t('componentsReply.inputComplaintProblem')"
                v-model="form.complainQuestion"
                clearable>
                </el-input>
            </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
            <div class="col-1 require">{{$t('componentsReply.contacts')}}：</div>
            <div class="col-2">
                <el-input
                :placeholder="$t('componentsReply.inputContacts')"
                v-model="form.contacts"
                readonly
                clearable>
                </el-input>
            </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
            <div class="col-1 require">{{$t('componentsReply.contactNumber')}}：</div>
            <div class="col-2">
                <el-input
                :placeholder="$t('componentsReply.inputContactNumber')"
                v-model="form.contactsPhone"

                readonly
                clearable>
                </el-input>
            </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
            <div class="col-1 require">{{$t('deviceListDetail.address')}}：</div>
            <div class="col-2">
                <el-input
                :placeholder="$t('componentsReply.inputAddress')"
                readonly
                v-model="form.address"
                clearable>
                </el-input>
            </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
        <div class="col-1">{{$t('componentsReply.explain')}}：</div>
        <div class="col-2">
            <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :placeholder="$t('componentsReply.otherRemarkInfo')"
            clearable
            maxlength="120"
            show-word-limit
            v-model="form.remark">
            </el-input>
        </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'all'">
        <div class="col-1">{{$t('componentsReply.explain')}}：</div>
        <div class="col-2">
            <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :placeholder="$t('componentsReply.otherRemarkInfo')"
            clearable
            maxlength="120"
            show-word-limit
            v-model="form.reply">
            </el-input>
        </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'mine'">
        <div class="col-1">{{$t('componentsReply.image')}}：</div>
        <div class="col-2">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'photoList') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'photoList') }"
              :file-list="form.photoList"
              :on-exceed="handleExceed"
              :limit="3"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('componentsReply.onlyThreeImage')}}</div>
            </el-upload>
        </div>
      </div>
      <div class="row"  v-if="defaultInfo.modalType === 'all'">
        <div class="col-1">{{$t('componentsReply.image')}}：</div>
        <div class="col-2">
            <el-upload
              class="upload-demo"
              action=""
              accept="image/jpg, image/png, image/jpeg"
              :auto-upload="false"
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'imgList') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'imgList') }"
              :file-list="form.imgList"
              :on-exceed="handleExceed"
              :limit="3"
              list-type="picture">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('componentsReply.mostThreeImage')}}</div>
            </el-upload>
        </div>
      </div>
      <div class="row" v-if="defaultInfo.modalType === 'all'">
        <div class="col-1">{{$t('componentsReply.enclosure')}}：</div>
        <div class="col-2">
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              action=""
              :on-change="function(file, fileList) { return uploadFile(file, fileList, 'attachment') }"
              :on-preview="handlePreview"
              :on-remove="function(file, fileList) { return handleRemove(file, fileList, 'attachment') }"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="form.attachment">
              <el-button size="small" type="primary">{{$t('componentsReply.uploadClick')}}</el-button>
            </el-upload>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" :loading="loading">{{$t('editChild.submit2')}}</el-button>
        <el-button @click="handleClose">{{$t('indexTags.cancel2')}}</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile } from "@/api/goods"
import {
  shopComplaintEdit,
  areaComplaintEdit,
  generalComplaintEdit,
  shopComplaintProcess,
  areaComplaintProcess,
  generalComplaintProcess,
  listComplaintObject,
  generalComplaintpost,
  shopComplaintpost,
} from "@/api/shopComplain"
  export default {
    props: {
      visible: { default: false },
      defaultInfo: {
        default: () => {
            return {};
        }
      },
    },
    data() {
      return {
        form: {
            imgList: [],
            photoList: [],
            attachment: [],
            complainObj: '',
            complainQuestion: '',
            contacts: '',
            contactsPhone: '',
            address: '',
            reply: '',
            remark: '',
        },
        complainObjOptions: [],
        newApi: null,
        editApi: null,
        processApi: null,
        loading: false,
      }
    },
    computed: {
       postParams() {
        const _return = {
            name: this.defaultInfo.name,
            id: this.defaultInfo.id,
            complaintObject: this.form.complainObj,
            complaintIssues: this.form.complainQuestion,
            linkUser: this.defaultInfo.linkUser?this.defaultInfo.linkUser:this.form.contacts,
            linkPhone:  this.defaultInfo.linkPhone?this.defaultInfo.linkPhone:this.form.contactsPhone,
            address: this.defaultInfo.address?this.defaultInfo.address: this.form.address,
            reply: this.form.reply,
            remark: this.form.remark,
            photo: this.form.photoList.length ? this.form.photoList.map(x => x.url).join(",") : '',
            servicePhoto: this.form.imgList.length ? this.form.imgList.map(x => x.url).join(",") : '',
            serviceAttach: this.form.attachment.length ? this.form.attachment.map(v => v.url).join(",") : '',
            serviceAttachName: this.form.attachment.length ? this.form.attachment.map(c => c.name).join(",") : '',
        }
        return _return;
       },
      replyParams() {
        const _return = {
            id: this.defaultInfo.id,
            reply: this.form.reply,
            servicePhoto: this.form.imgList.length ? this.form.imgList.map(x => x.url).join(",") : '',
            serviceAttach: this.form.attachment.length ? this.form.attachment.map(v => v.url).join(",") : '',
            serviceAttachName: this.form.attachment.length ? this.form.attachment.map(c => c.name).join(",") : '',
        }
        return _return;
       },
    },
    created() {
      console.log('this.defaultInfo', this.defaultInfo);
      if(this.defaultInfo.modalType === 'mine') {
        this.getComplainObjList();
      }
      if(this.defaultInfo.linkPhone){
        this.$set(this.form,'address', this.defaultInfo.address)
        this.$set(this.form,'contacts', this.defaultInfo.linkUser)
        this.$set(this.form,'contactsPhone', this.defaultInfo.linkPhone)

      }
    },
    methods: {
      hadleEditApiChange(e) {
        switch(e) {
            case '1':
                return generalComplaintEdit;
            case '2':
                return areaComplaintEdit;
            case '3':
                return shopComplaintEdit;
        }
      },
      handleProcessApiChange(e) {
        switch(e) {
            case '1':
                return generalComplaintProcess;
            case '2':
                return areaComplaintProcess;
            case '3':
                return shopComplaintProcess;
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(this.$t('componentsReply.momentLimitThree') + `${files.length}` + this.$t('componentsReply.aTotalOf') + `${files.length + fileList.length}`+ this.$t('componentsReply.individualFile'));
      },
      handleRemove(file, fileList, target) {
        let currentIndex;
        this.form[target].map((x,idx) => {
          if(file.uid === x.uid) {
            currentIndex = idx;
          }
        })
        this.form[target].splice(currentIndex, 1);
        console.log(this.form[target], target);
      },
      handlePreview(file) {
        console.log(file);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(this.$t('componentsReply.sureRemove') + `${ file.name }？`);
      },
      async uploadFile(file, fileList, target) {
        console.log('file', file);
        console.log('target', target)
        let fileList1 = [];
        let FormDatas = new FormData()
        FormDatas.append('file',file.raw);
        let { data } = await uploadFile(FormDatas);
        console.log('data', data)
        if(data && data.code === 200) {
          this.$message.success(this.$t('AAAA.uploadSuccess'))
          let obj = {
            domain: data.data.domain,
            status: "success",
            name: data.data.originalName,
            size: file.size,
            url: data.data.link,
          }
          this.form[target].push(obj)
        } else {
          for(var i = 0; i < fileList1.length; i++){
            if(i + 1 == fileList1.length){
              fileList1.splice(i,1)
            }
          }
          this.$message.error(data.msg)
          return
        }
      },
      verifyPhoneNum(e) {
        console.log(e);
        let flag = true;
        let reg_phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if(!reg_phone.test(this.form.contactsPhone)){
            this.$message.error(this.$t('componentsReply.inputRightPhoneNum'))
            flag = false;
        }
        return flag;
      },
      checkForm() {
        let msg = "";
        let _return = true;
        if(_return) {
            if(!this.form.complainObj || this.form.complainObj.length === 0) {
            msg = this.$t('componentsReply.choComplaintObject');
            _return = false;
            }

            if(!this.form.complainQuestion || this.form.complainQuestion.length === 0) {
            msg = this.$t('componentsReply.inputComplaintProblem');
            _return = false;
            }

            if(!this.form.contacts || this.form.contacts.length === 0) {
            msg = this.$t('componentsReply.inputContacts');
            _return = false;
            }

            if(!this.verifyPhoneNum) {
            msg = this.$t('componentsReply.checkPhoneNumRight');
            _return = false;
            }

            if(!this.form.contactsPhone || this.form.contactsPhone.length === 0) {
            msg = this.$t('componentsReply.inputContactNumber');
            _return = false;
            }

            if(!this.form.address || this.form.address.length === 0) {
            msg = this.$t('componentsReply.inputAddress');
            _return = false;
            }
        }

        if (!_return) {
            this.$message.error(msg);
        }
        return _return;
      },
      handleClose() {
        this.$emit("update:visible", false);
      },
      // 回复编辑
      async replyComplain() {
        try {
          this.loading = true;
            this.editApi = this.hadleEditApiChange(this.defaultInfo.source.toString());
            const res = await this.editApi(this.replyParams);
            console.log('编辑回复 =>', res.data);
            if(res.data && res.data.code === 200) {
                let isHadnle = await this.handleProcess();
                console.log('isHadnle', isHadnle);
                if(isHadnle) {
                    this.$emit('updateDetail');
                    this.$message.success(this.$t('componentsReply.replySuccess'))
                    this.handleClose();
                }
            }
            this.loading = false;
        } catch(e) {
            this.$message.error(e.toString())
        }
      },
      // 处理投诉
      async handleProcess() {
        try {
          let flag = false;
          this.processApi = this.handleProcessApiChange(this.defaultInfo.source.toString());
          const res = await this.processApi({
            id: this.defaultInfo.id,
            processInstanceId: this.defaultInfo.processInstanceId,
            processDefinitionId: this.defaultInfo.processDefinitionId,
            businessId: this.defaultInfo.id,
          
            source: this.defaultInfo.source,
            flag:"ok"
          })
          console.log('处理回复= >', res.data);
          if(res.data && res.data.code === 200) {
            flag = true;
          }
          return flag
        } catch(e) {
            this.$message.error(e.toString())
        }
      },
      // 获取投诉对象
      async getComplainObjList() {
         try {
          const res = await listComplaintObject();
          console.log('complainObj', res.data);
          if(res.data && res.data.code === 200) {
            this.complainObjOptions = res.data.data;
          }
         } catch(e) {
          this.$message.error(e.toString())
         }
      },
      // 我的投诉新增
      async submit() {
         console.log(this.postParams);
        this.loading = true;
        let Api = this.website.roleType == 'shop' ? shopComplaintpost:generalComplaintpost
        const res = await Api(this.postParams);
         if(res.data && res.data.code === 200) {
          this.$message.success(this.$t('componentsReply.addSuccess'));
          setTimeout(() => {
            this.$emit('updateList');
            this.handleClose();
          })
         }
         this.loading = false;
      },
      confirm() {
        if(this.defaultInfo.modalType === 'mine') {
          if(this.checkForm()) {
            if(!this.defaultInfo.id) {
              this.submit()
            }
          }
        } else {
            this.replyComplain();
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.form-box {
    padding: 20px 20px;
}
.row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.require {
    &::before {
    content: "*";
    color: red;
    margin-right: 2px;
    }
}
.col-1 {
    min-width: 15%;
}
.col-2 {
    flex: 1;
}
/deep/ .upload-demo .el-button {
    background-color: #01AAA7;
    color: #fff;
    border-color: #01AAA7;
}
</style>
